/**
 * قاموسُ الأنجلزة: المصدرُ العربيُّ ← الإنجليزيّة.
 *
 * المرحلةُ الأولى تغطّي الهيكلَ العامّ (القوائم، الشريطُ العلويّ، تسجيلُ
 * الدخول، الأزرارُ العامّة، عناوينُ الرئيسيّة). ما لا يُوجَد هنا يظلّ عربيًّا
 * ريثما يُترجَم على دفعات. أضف مدخلاتٍ لتوسيعِ التغطية.
 */
export const EN: Record<string, string> = {
  // ---- اللغة ----
  'اللغة': 'Language',
  'العربية': 'العربية',
  'English — قريبًا': 'English',
  'English': 'English',

  // ---- الشريط العلويّ والحساب ----
  'حسابي': 'My account',
  'ملفّي': 'My profile',
  'الملف الشخصي': 'Profile',
  'الإعدادات': 'Settings',
  'الإشعارات': 'Notifications',
  'تسجيل الخروج': 'Sign out',
  'الخروج': 'Sign out',
  'بحث': 'Search',
  'القائمة': 'Menu',

  // ---- مجموعات القوائم ----
  'نظرة عامة': 'Overview',
  'إدارة العملاء': 'CRM',
  'قاعدة العملاء': 'Customer base',
  'رحلة العميل': 'Customer journey',
  'خطوط العمل': 'Work lines',
  'المبيعات': 'Sales',
  'الصفقات': 'Deals',
  'مركز الاتصال': 'Call center',
  'مركز المراقبة': 'Monitoring',
  'المراقبة': 'Monitoring',
  'التواصل': 'Communication',
  'إدارة المشاريع': 'Projects',
  'العمل': 'Work',
  'الحسابات': 'Accounting',
  'الدفتر العام': 'General ledger',
  'الخزينة': 'Treasury',
  'الذمم': 'Receivables & payables',
  'المشتريات والمصروفات': 'Purchases & expenses',
  'الأصول الثابتة': 'Fixed assets',
  'الموارد البشرية': 'Human resources',
  'شؤون العاملين': 'Personnel',
  'الرواتب والمزايا': 'Payroll & benefits',
  'التوظيف والاستقطاب': 'Recruitment',
  'إدارة المواهب': 'Talent management',
  'التدريب والتطوير': 'Training & development',
  'إدارة الأداء': 'Performance management',
  'التطوير التنظيمي': 'Organizational development',
  'التنظيم': 'Organization',
  'علاقات الموظفين': 'Employee relations',
  'التقارير': 'Reports',
  'الشركة': 'Company',
  'الفريق': 'Team',
  'المستخدمون والصلاحيات': 'Users & permissions',
  'المستندات': 'Documents',
  'التكاملات': 'Integrations',
  'الإدارة': 'Administration',
  'الإعداد': 'Setup',
  'بياناتي': 'My data',
  'تفضيلاتي': 'My preferences',
  'عملي': 'My work',

  // ---- عناصر القوائم ----
  'الرئيسية': 'Home',
  'أعمالي': 'My work',
  'مهامي': 'My tasks',
  'طلباتي': 'My requests',
  'الأنشطة': 'Activities',
  'التقويم': 'Calendar',
  'الاجتماعات': 'Meetings',
  'الاجتماعات والحجز': 'Meetings & booking',
  'العملاء': 'Accounts',
  'العملاء المحتملون': 'Leads',
  'جهات الاتصال': 'Contacts',
  'قمع المبيعات': 'Sales funnel',
  'المسار': 'Pipeline',
  'تقييم العملاء': 'Customer scoring',
  'الحقول المخصَّصة': 'Custom fields',
  'قوائم القيم': 'Value lists',
  'عروض الأسعار': 'Quotations',
  'العقود': 'Contracts',
  'العقود والتجهيز': 'Contracts & onboarding',
  'كتالوج الخدمات': 'Service catalog',
  'باقات العملاء': 'Client packages',
  'الطلبات': 'Orders',
  'قواعد الطلبات': 'Order rules',
  'العمولات': 'Commissions',
  'العمولات والخصومات': 'Commissions & discounts',
  'عمولاتي': 'My commissions',
  'أهداف المندوبين': 'Rep targets',
  'الأهداف': 'Targets',
  'فريق المبيعات': 'Sales team',
  'المحافظ': 'Portfolios',
  'المشاريع': 'Projects',
  'قوالب المشاريع': 'Project templates',
  'صفحات الحجز': 'Booking pages',
  'الاتصال والنتائج والتسجيل': 'Calls, outcomes & recording',
  'سجلّ المكالمات': 'Call log',
  'جودة المكالمات': 'Call quality',
  'قواعد الرصد': 'Monitoring rules',
  'شاشة المراقبة': 'Monitoring screen',
  'غرفة العمليات': 'Operations room',
  'الحالات والإجراءات والرضا': 'Cases, actions & satisfaction',
  'الأتمتة وإشعارات العميل': 'Automation & client alerts',
  'قنوات ميتا': 'Meta channels',
  'المصفوفة والشركاء': 'Matrix & partners',
  'البريد الإلكتروني': 'Email',
  'البريد الوارد': 'Inbox',
  'الرسائل المحفوظة': 'Saved messages',
  'دليل الحسابات': 'Chart of accounts',
  'القيود اليومية': 'Journal entries',
  'القوائم المالية': 'Financial statements',
  'البنوك والخزائن': 'Banks & cash',
  'فواتير العملاء': 'Customer invoices',
  'فواتير الموردين': 'Supplier invoices',
  'أرصدة العملاء': 'Customer balances',
  'أرصدة الموردين': 'Supplier balances',
  'التحصيلات': 'Collections',
  'المصروفات': 'Expenses',
  'الموردون': 'Suppliers',
  'متابعة الائتمان': 'Credit follow-up',
  'قواعد الائتمان': 'Credit rules',
  'تقادم الذمم': 'Receivables aging',
  'الاشتراكات الدورية': 'Recurring subscriptions',
  'سجل الأصول': 'Asset register',
  'فئات الأصول والإهلاك': 'Asset categories & depreciation',
  'الإهلاك': 'Depreciation',
  'الإعدادات المالية': 'Finance settings',
  'ملفات الموظفين العاملين': 'Employee files',
  'الحضور': 'Attendance',
  'الإجازات': 'Leaves',
  'إجازاتي': 'My leaves',
  'الورديات ومراكز التكلفة': 'Shifts & cost centers',
  'هيكل الرواتب والدرجات': 'Salary structure & grades',
  'دورات المرتب': 'Payroll runs',
  'رواتبي': 'My payslips',
  'المزايا والتأمين الطبي': 'Benefits & medical insurance',
  'التأمينات والضريبة': 'Insurance & tax',
  'عقود العمل': 'Employment contracts',
  'حملات التعيين': 'Hiring campaigns',
  'استمارات التقديم': 'Application forms',
  'طلبات التقديم': 'Applications',
  'ملفات المرشّحين للتعيين': 'Candidate files',
  'مواعيد المقابلات': 'Interview schedule',
  'الأوصاف الوظيفية': 'Job descriptions',
  'الوظائف': 'Positions',
  'الهيكل التنظيمي': 'Org chart',
  'الهيكل': 'Structure',
  'الوحدات التنظيمية': 'Org units',
  'مواقع العمل': 'Work locations',
  'فريق العمل': 'Workforce',
  'تخطيط القوى العاملة': 'Workforce planning',
  'خطط الإحلال': 'Succession plans',
  'الاحتياجات والدورات': 'Needs & courses',
  'الأداء: دورات وأهداف وخطط': 'Performance: cycles, goals & plans',
  'لوحة الأداء': 'Performance board',
  'المستخدمون': 'Users',
  'ملفّات الصلاحيات': 'Permission profiles',
  'بيانات الشركة': 'Company profile',
  'الهوية والمستندات': 'Branding & documents',
  'المستندات والأوراق': 'Documents & stationery',
  'سجل التدقيق': 'Audit log',
  'الحماية': 'Security',
  'الاشتراك والدفع': 'Subscription & billing',
  'تصدير واستيراد': 'Export & import',
  'تطبيق سطح المكتب': 'Desktop app',
  'إذن مراقبة الشاشة': 'Screen monitoring consent',
  'إعدادات المراقبة': 'Monitoring settings',
  'التقارير المنشورة': 'Published reports',
  'باني التقارير': 'Report builder',
  'لوحة المؤشّرات': 'Dashboard',
  'لوحة المعلومات': 'Dashboard',
  'لوحة اليوم': "Today's board",
  'الجرد': 'Inventory',
  'تحليل الخسائر': 'Loss analysis',
  'الباقات': 'Plans',
  'الكونسول': 'Console',
  'عهدتي': 'My custody',
  'عقود العمل ': 'Employment contracts',
  'Google Drive': 'Google Drive',

  // ---- أزرار وإجراءات عامّة ----
  'حفظ': 'Save',
  'إلغاء': 'Cancel',
  'إضافة': 'Add',
  'تعديل': 'Edit',
  'حذف': 'Delete',
  'إغلاق': 'Close',
  'رجوع': 'Back',
  'التالي': 'Next',
  'السابق': 'Previous',
  'تأكيد': 'Confirm',
  'موافق': 'OK',
  'نعم': 'Yes',
  'لا': 'No',
  'تحميل': 'Download',
  'معاينة': 'Preview',
  'طباعة': 'Print',
  'تصدير': 'Export',
  'استيراد': 'Import',
  'الكل': 'All',
  'قريبًا': 'Soon',
  'قيد الإنشاء': 'Coming soon',
  'التطبيقات': 'Apps',

  // ---- تسجيل الدخول ----
  'تسجيل الدخول': 'Sign in',
  'كلمة المرور': 'Password',
  'إظهار كلمة المرور': 'Show password',
  'إخفاء كلمة المرور': 'Hide password',
  'تذكّرني': 'Remember me',
  'نسيت كلمة المرور؟': 'Forgot password?',
  'تأكيد الدخول من جهاز جديد': 'Confirm sign-in from a new device',
  'رمز التأكيد': 'Verification code',
  'تأكيد الدخول': 'Confirm sign-in',
  'الثقة بهذا الجهاز — لا تطلب الرمز عليه لاحقًا': "Trust this device — don't ask for the code again",
  'دخول العملاء': 'Client sign-in',
};
